
export class TipoMediador {

    public id: string;
    public nome: string;

    constructor(){
        
    }
}
